import dayjs from 'dayjs';
import { isNonNullish, isNullish } from 'remeda';

import { emptyLottery, PartnerSpotlightForm } from './form';

import { PartnerSpotlightPayload } from 'v2/api/partnerSpotlightService';
import { PartnerSpotlightLottery, PartnerSpotlightModel } from 'v2/types/PartnerSpotlightModel';

const buildLotteryPlaceholderDto = (): PartnerSpotlightLottery => ({
  imageId: '',
  description: '',
  promoTexts: [],
  endDate: dayjs().format(),
});

export function graphemeLength(value: string): number {
  if (!value) return 0;
  return Array.from(value).length;
}

export function mapDtoToForm(dto: PartnerSpotlightModel): PartnerSpotlightForm {
  const lotteryEnabled = dto.isLotteryActive ?? false;

  return {
    partnerId: dto.partnerId,
    status: dto.status,
    backgroundImageId: dto.backgroundImageId,
    isBackgroundOnly: dto.isBackgroundOnly,
    hasNewBadge: dto.hasNewBadge ?? false,
    bonusReceivedText: dto.bonusReceivedText ?? '',
    extraOfferText: dto.extraOfferText ?? '',
    lotteryEnabled,
    lottery:
      lotteryEnabled && isNonNullish(dto.lottery)
        ? {
            imageId: dto.lottery.imageId,
            description: dto.lottery.description,
            promo1: dto.lottery.promoTexts[0] ?? '',
            promo2: dto.lottery.promoTexts[1] ?? '',
            endDate: dayjs(dto.lottery.endDate),
          }
        : emptyLottery,
  };
}

export function mapFormToDto(form: PartnerSpotlightForm, options?: { isActive?: boolean }): PartnerSpotlightPayload {
  const isLotteryActive = form.lotteryEnabled && !isNullish(form.lottery.endDate);

  const payload: PartnerSpotlightPayload = {
    partnerId: form.partnerId,
    status: form.status,
    backgroundImageId: form.backgroundImageId,
    isBackgroundOnly: form.isBackgroundOnly,
    hasNewBadge: form.hasNewBadge,
    bonusReceivedText: form.bonusReceivedText.trim(),
    extraOfferText: form.extraOfferText.trim(),
    isLotteryActive,
    lottery: isLotteryActive
      ? {
          imageId: form.lottery.imageId,
          description: form.lottery.description,
          promoTexts: [form.lottery.promo1, form.lottery.promo2].map((s) => s.trim()).filter((s) => s.length > 0),
          endDate: form.lottery.endDate!.startOf('minute').format(),
        }
      : buildLotteryPlaceholderDto(),
  };

  if (options?.isActive !== undefined) {
    payload.isActive = options.isActive;
  }

  return payload;
}
